import { render } from "./FotterView.vue?vue&type=template&id=5fc3ad44&scoped=true"
import script from "./FotterView.vue?vue&type=script&lang=js"
export * from "./FotterView.vue?vue&type=script&lang=js"

import "./FotterView.vue?vue&type=style&index=0&id=5fc3ad44&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.2.2_b3222d3da5d2ef56209cdae4c4adc42e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc3ad44"]])

export default __exports__